import { AfterViewInit, Component, OnInit } from '@angular/core';
declare function $(string:string): any;

@Component({
  selector: 'app-e-house',
  templateUrl: './e-house.component.html',
  styleUrls: ['./e-house.component.scss']
})
export class EHouseComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }
  ngAfterViewInit(){
    $('img.lightbox').lightBox(); // Select all links with lightbox class

  }
}
